import {FarmFeaturesModel} from '../../model/users/FarmFeaturesModel.js';
import {BaseCollection} from '../BaseCollection';

/**
 * @class PermissionCollection
 * @extends BaseCollection
 * @deprecated  Due to endpoint breaking change. New endpoint provides a more detailed information about
 *              crop-specific features and related packages. FarmFeatures2Collection to be used instead.
 */
export class FarmFeaturesCollection extends BaseCollection {

    initialize (models, options) {

        super.initialize(models, options);

        this.microservice = 'users';
        this.resource = 'farm-features';
    }

    get model () {

        return FarmFeaturesModel;
    }
}


// WEBPACK FOOTER //
// ./shared/collection/users/FarmFeaturesCollection.js